export const VINEOPS_URL = "https://www.vineopsvvm.com/login";

export const CONTACT = {
  phone: "(707) 555-0184",
  email: "info@vinedresservm.com",
  address: "Napa, California",
};

export const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.6 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1701624019104-d37423bd30bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHw0fHxuYXBhJTIwdmFsbGV5JTIwdmluZXlhcmQlMjBhZXJpYWwlMjBzdW5yaXNlfGVufDB8fHx8MTc4ODE0NTQ1OHww&ixlib=rb-4.1.0&q=85",
  hands: "/assets/philosophy-grapes.webp",
  ground: "/assets/ground-vineyard.jpg",
  season: "/assets/season-vine.webp",
  record: "/assets/record-vineops.jpg",
  grapes: "https://images.unsplash.com/photo-1784021787786-65ac3f5380c2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxtYWNybyUyMHdpbmUlMjBncmFwZXMlMjBoYW5kcyUyMGZhcm1pbmd8ZW58MHx8fHwxNzg4MTQ1NDU4fDA&ixlib=rb-4.1.0&q=85",
  rows: "https://images.unsplash.com/photo-1560493676-04071c5f467b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxwcmVjaXNpb24lMjBmYXJtaW5nJTIwYWdyaWN1bHR1cmUlMjB0ZWNobm9sb2d5fGVufDB8fHx8MTc4ODE0NTQ1OHww&ixlib=rb-4.1.0&q=85",
  aerial: "https://images.unsplash.com/photo-1700895635991-7bd436ed6fdb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxuYXBhJTIwdmFsbGV5JTIwdmluZXlhcmQlMjBhZXJpYWwlMjBzdW5yaXNlfGVufDB8fHx8MTc4ODE0NTQ1OHww&ixlib=rb-4.1.0&q=85",
};
